"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateWrapper = exports.DescriptionWrapper = exports.TitleWrapper = exports.TitleLinkWrapper = exports.CategoryWrapper = exports.StyledCardWrapper = exports.StyledBlock = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const link_1 = require("../utils/link");
exports.StyledBlock = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${(0, wl_ui_kit_1.getSizeBy)()};
`;
exports.StyledCardWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${(0, wl_ui_kit_1.getSizeBy)(2)};
  padding: ${(0, wl_ui_kit_1.getSizeBy)(2)} ${(0, wl_ui_kit_1.getSizeBy)(3)};
  border-bottom: 1px solid ${(0, wl_ui_kit_1.getColorShade)('onSurface', 'outline')};
`;
exports.CategoryWrapper = (0, styled_components_1.default)(wl_ui_kit_1.Overline) `
  padding: ${(0, wl_ui_kit_1.getSizeBy)()} 0;
  color: ${(0, wl_ui_kit_1.getColorShade)('onSurface', 'highEmphasis')};
`;
exports.TitleLinkWrapper = (0, styled_components_1.default)(link_1.SideBarLink) `
  ${wl_ui_kit_1.Body1Styles};
`;
exports.TitleWrapper = (0, styled_components_1.default)(wl_ui_kit_1.Body1) ``;
exports.DescriptionWrapper = (0, styled_components_1.default)(wl_ui_kit_1.Body2) `
  color: ${(0, wl_ui_kit_1.getColorShade)('onSurface', 'mediumEmphasis')};
`;
exports.DateWrapper = (0, styled_components_1.default)(wl_ui_kit_1.Caption) `
  color: ${(0, wl_ui_kit_1.getColorShade)('onSurface', 'mediumEmphasis')};
`;
